import React, { useState, useEffect } from 'react';
import _ from "lodash";
import SearchBar from '../search/SearchBar';
import UsageEventsTreeView from './UsageEventsTreeView';
import moment from "moment";
import { fetchUsageEvents } from "../../utils/api"
import UsageEventsContentTabs from "./UsageEventsContentTabs"
import { Spinner } from "../common/Spinner";

import { Error } from "../common/Error";


const UsageEventContainer = (): any => {

  const [searchValue, setSearchValue] = useState("" as string);
  const [usageEvents, setUsageEvents] = useState([] as any);
  const [sortEvents, setSortEvents] = useState("desc" as any);
  const [eventDetail, setEventDetail] = useState("" as any);
  const [isLoading, setIsLoading] = useState(false as boolean);
  const [isDataFetchCompleted, setIsDataFetchCompleted] = useState(false as boolean);
  const [errors, setErrors] = useState([]);

  const onTreeItemSelect = (data: any) => {
    setEventDetail(data)
  }
  const onSearchHandler = () => {
    resetState();
    setIsLoading(true);
    setSearchValue(searchValue);
    getUsageEvents();
  }

  const onResetHandler = () => {
    resetState();
  }

  const resetState = () => {
    setErrors([]);
    setIsLoading(false)
    setSearchValue("");
    setUsageEvents([]);
    setEventDetail("");
    setIsDataFetchCompleted(false);
  }

  const onInputChangeHandler = (data: any) => {
    setSearchValue(data);
  }
  const sortUsageEvents = () => {
    const SortedEvents = _.orderBy(usageEvents,
      function (sortObj: any) {
        return moment(sortObj.timestamp).format(moment.HTML5_FMT.DATETIME_LOCAL_MS);
      }, [sortEvents]);
    setUsageEvents(SortedEvents);
  }

  useEffect(
    () => {
      if (sortEvents) {
        sortUsageEvents();
      }
    },
    [sortEvents],
  );

  const getUsageEvents = () => {
    fetchUsageEvents(searchValue)
      .then(response => response.json())
      .then(result => {
        if (result.message) {
          setIsLoading(false);
          setErrors(result.message);
        } else {
          setUsageEvents(result.response);
          setIsDataFetchCompleted(true);
          setIsLoading(false);
          setErrors([]);
        }
      })
      .catch(error => {
        setIsLoading(false);
        setErrors(error.message);
      });
  }

  const sortUsageEventHandler = () => {
    setSortEvents(sortEvents === "asc" ? "desc" : "asc");
  }

  return (
    <div className="container-flex w-100" >
      <SearchBar searchValue={searchValue} searchHandler={onSearchHandler} resetHandler={onResetHandler} inputChangeHandler={onInputChangeHandler} />
      { usageEvents && usageEvents.length > 0 &&
        <div className="row mx-0 pt-2" >
          < UsageEventsTreeView items={usageEvents} sortUsageEventHandler={sortUsageEventHandler} searchValue={searchValue} handleItemSelect={onTreeItemSelect} />
          {eventDetail &&
            <UsageEventsContentTabs eventDetail={eventDetail} />
          }
        </div>
      }
      { isDataFetchCompleted && usageEvents && usageEvents.length == 0 && <div className="row w-100 d-flex justify-content-center" ><Error message="No data available." /></div>}
      {errors && <div className="row w-100 d-flex justify-content-center" ><Error message={errors} /></div>}
      { isLoading && usageEvents && usageEvents.length == 0 &&
        <Spinner />
      }
    </div>
  )
}

export default UsageEventContainer;